/** Комментарий участника в маршруте/истории — выделенная плашка, чтобы не терялся среди шагов. */
import { Text, XStack } from 'tamagui'

import { tone } from '../../../theme/tones'
import { Icon } from '../../../ui'

export function CommentNote({ text }: { text: string }) {
  const tn = tone('gold')
  return (
    <XStack gap={7} marginTop={6} borderRadius={7} borderLeftWidth={3} borderColor={tn.solid} backgroundColor={tn.soft} paddingHorizontal={10} paddingVertical={7}>
      <Icon name="message-square" size={13} color={tn.text} />
      <Text flex={1} minWidth={0} fontSize={12} color="$color">
        {text}
      </Text>
    </XStack>
  )
}
